// get data for displaying a space page - RoomPage.vue
// https://mccglc.atlassian.net/l/c/m0wi0wmv for DOCS

const state = {
  // current space page data ------------------------------------------
  currentSpacePage: {},
  loadingSpace: false,

  lobbyEnabled: false,
  passwordEnabled: false
};

const getters = {
  // current space page data ------------------------------------------
  getCurrentSpacePageData: (state) => state.currentSpacePage,
  getSpaceLocationData: (state) => state.currentSpacePage?.location,
  // current space you are looking at ---------------------------------
  // location (updatable space page data)
  getSpacePageId: (state,getters) => {
    return getters.getCurrentSpacePageData?.id || ''
  },
  getSpaceType: (state,getters) => {
    return getters.getSpaceLocationData?.spaceType || ''
  },
  getSpaceName: (state,getters) => {
    let locationType = getters.getCurrentLocationType
    return (locationType == 'space' ? getters.getSpaceLocationData?.name : getters.getCurrentSpacePageData?.name) || ''
  },
  getSpaceParticipantsNo: (state,getters) => {
    return getters.getSpaceLocationData?.online || 0
  },
  // space page data (other)
  getSpaceFirebaseId: (state,getters) => {
    return getters.getCurrentSpacePageData?.sourceId || ''
  },
  getSpaceDescription: (state,getters) => {
    return getters.getCurrentSpacePageData?.description || ''
  },
  getSpaceConferenceType: (state,getters) => {
    return getters.getCurrentSpacePageData?.conferenceType || ''
  },
  getSpaceJoinLink: (state,getters) => {
    return getters.getCurrentSpacePageData?.joinLink || ''
  },
  getSpaceParentName: (state,getters) => {
    return getters.getSpaceLocationData?.parentName || ''
  },
  getSpaceStartTime: (state,getters) => {
    return getters.getCurrentSpacePageData?.startTime || ''
  },
  getSpaceEndTime: (state,getters) => {
    return getters.getCurrentSpacePageData?.endTime || ''
  },
  getSpaceHostEmail: (state,getters) => {
    return getters.getCurrentSpacePageData?.hostEmail || ''
  },
  getSpaceBaseAngle: (state,getters) => {
    return getters.getSpaceLocationData?.baseAngle || 0
  },
  getSpaceImage: (state, getters) => {
    return getters.getSpaceLocationData?.imageUrl
  },
  getSpaceColour: (state, getters) => {
    return getters.getSpaceLocationData?.color
  },
  getSpaceTextColor: (state, getters) => {
    return getters.getSpaceLocationData?.textColor
  },
  getSpaceHideName: (state, getters) => {
    return getters.getSpaceLocationData?.hideName
  },
  getSpaceIfPortal: (state, getters) => {
    return getters.getSpaceLocationData?.spaceType === 'portal' || getters.getSpaceLocationData?.spaceType === '6'
  },
  getSpaceLobbyEnabled: (state) => {
    return state.lobbyEnabled
  },
  getSpacePasswordEnabled: (state) => {
    return state.passwordEnabled
  },
  // see search > searchParticipants for participants

  getLoadingSpace: state => state.loadingSpace
};

const mutations = {
  // current space page data ---------------------------------------
  setCurrentSpacePage(state, data) {
    state.currentSpacePage = data;
    state.passwordEnabled = Boolean(data.passwordEnabled)
    state.lobbyEnabled = Boolean(data.lobbyEnabled)
  },
  PASSWORD_ENABLED(state, enabled) {
    state.passwordEnabled = enabled
  },
  LOBBY_ENABLED(state, enabled) {
    state.lobbyEnabled = enabled
  },
  setLoadingSpace: (state, data) => state.loadingSpace = data
};

const actions = {
  // current space page data ----------------------------------
  async updateCurrentSpacePage({getters,commit,dispatch}, data) {
    let spaceData = getters.getCurrentSpacePageData || {}
    let updateData = data.location ? data : {...spaceData,location: data}

    // ensures everywhere that has the space data is updated
    if(updateData?.location) {
      updateData.name = updateData.location.name;
    }
    updateData.passwordEnabled = data.passwordEnabled;
    updateData.lobbyEnabled = data.lobbyEnabled

    commit('setCurrentSpacePage', updateData)

    let online = updateData?.location?.online;

    // get participants only when there are users in the room + no live updating when in call
    if(!online) {
      dispatch('search/clearSpaceParticipants')
    }
    return
  },
  async clearCurrentSpacePage({commit, dispatch}) {
    dispatch('search/clearSpaceParticipants')
    commit('setCurrentSpacePage',{})
    return
  },
  // enter space ----------------------------------------------
  async enterCurrentUsersSpace({getters,dispatch}) {
    dispatch('routing/goToRoom', getters.getCurrentUsersRoomId)
    //rejoin room without lobby
  },
  async enterSpaceCallback({dispatch},res) {
    if(res.success) {
      let data = res.success
      await dispatch('updateLocation',[data])
    } else {
      dispatch('popups/nav/errorJoiningRoom')
      //if on space page, move back to area page
      dispatch('routing/goToHome')
    }
  },
  async getUpdatedSpaceData({commit, dispatch}, id) {
    let res = await dispatch('api/nav/getRoom', id)
    let data = res?.success
    if(data) {
      commit('setCurrentSpacePage', data)
    }
    return data
  },
  stopViewingRoom({dispatch, getters}) {
    if(getters['routing/routeName'] !== 'area' || !getters.getCurrentSpacePageData?.id) return
    dispatch('routing/clearQuery')
    dispatch('clearCurrentSpacePage')
    if(getters['viewport/isMobile']) dispatch('sidebar/close') //close sidebar on mobile so doesn't open space info straight after
  },
  async viewRoom({dispatch, commit}, id) {
    dispatch('clearCurrentSpacePage')
    commit('setLoadingSpace', true)
    let res = await dispatch('api/nav/enterLocation', id)
    commit('setLoadingSpace', false)

    let isDeleted = res?.success?.isDeleted
    if(res.success && !isDeleted) { //don't let user view if deleted (resurrection)
      commit('setCurrentSpacePage', res.success)
      dispatch('sidebar/open', 'info')
      dispatch('search/clear')
      dispatch('analytics/viewRoom', res.success)
    } else {
      dispatch('popups/show/error/custom', 'viewing this Room', {root: true})
      //if on space page, move back to area page
      dispatch('routing/goToCurrentArea')
      //clear query
      dispatch('routing/clearQuery')
    }
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
